// Base breadcrumb styles (rendered inline — no inner breadcrumbs-type-1 component delegation)
sn-breadcrumbs-type-1 {
  .breadcrumbs-type-1 {
    background-color: var(--background-color-primary);

    &__list {
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: calc(var(--spacing-2xs) / 1.25);
    }

    &__item {
      display: flex;
      align-items: center;
      gap: calc(var(--spacing-2xs) * 1.2);

      &:last-child {
        .breadcrumbs-type-1__separator {
          display: none;
        }
      }
    }

    &__link,
    &__text {
      @include text-style('sm', 'md');

      color: var(--text-color-primary);
      text-decoration: none;
      transition: color 0.2s ease;

      @include below-desktop {
        @include text-style('xs', 'xs');
      }
    }

    &__link {
      &:hover {
        color: var(--color-brand-primary-dark);
      }
    }

    &__text {
      color: var(--text-color-primary);
      font-weight: map-get($font-weights, 'normal');
    }

    &__item--current {
      .breadcrumbs-type-1__text {
        color: color-mix(in srgb, var(--text-color-primary) 75%, transparent);
        font-weight: map-get($font-weights, 'normal');
        text-decoration: none;
      }
    }

    &__separator {
      display: flex;
      align-items: center;
      margin-top: 3px;
      color: var(--text-color-secondary);

      .me-icon {
        @include size(16px);

        svg {
          fill: var(--color-neutral-neutral-light);
        }
      }
    }
  }
}
